import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  uploadInvoice: 'Upload invoice',
  uploadInvoiceTitle: 'Attach a document or invoice (optional):',
  invoiceLabel: 'Attach invoice / receipt / evidence',
  androidDirections:
    'To select multiple files, you must long press each file for more than 3 seconds until it is selected.',
  itemsRequired: 'All fields are required',
  itemLengthError: 'The name can´t be longer than 30 characters',
  receivableName: 'Payment name',
  fundsNotEnough:
    'If you want to do a transaction from your wallet or schedule a payment, please add funds to your account',
  noteFunding: `Please add {{AMOUNT_CHANGE_CONTENT}} funds to be able to pay from your wallet.`,
  expireDeferred: `Deferred payments expire 3 hours after creation.`,
  confirmationMessage: 'Your request was sent to:',
  selectMultipleFiles:
    'To select multiple files, you must press ctrl (windows) or cmd (mac) and click on the files you want to select.',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const RECEIVABLES_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    uploadInvoice: 'Subir factura',
    uploadInvoiceTitle: 'Adjuntar un documento o factura (opcional):',
    invoiceLabel: 'Adjuntar factura / comprobante / evidencia',
    androidDirections:
      'Para seleccionar múltiples archivos, debe presionar por más de 3 segundos cada archivo hasta que quede seleccionado.',
    itemsRequired: 'Todos los campos son obligatorios',
    itemLengthError: 'El nombre no puede ser mayor a 30 carácteres.',
    receivableName: 'Nombre del pago',
    fundsNotEnough:
      'Si deseas realizar una transferencia desde tu wallet o programar un pago, por favor añade fondos a tu cuenta.',
    noteFunding: `Agrega a tu balance {{AMOUNT_CHANGE_CONTENT}} para poder pagar desde tu wallet.`,
    expireDeferred: `Los pagos diferidos expiran 3 horas después de su creación.`,
    confirmationMessage: 'Tu solicitud fue enviada a:',
    selectMultipleFiles:
      'Para seleccionar múltiples archivos, debes presionar ctrl (windows) o cmd (mac) y hacer clic en los archivos que deseas seleccionar.',
  },
};

export default RECEIVABLES_LANGUAGE_LABELS;
